/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface CheckService {
  /** @summary Ok */
  okCheckGet: {
    /** @summary Ok */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<OkCheckGetSchema, OkCheckGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<OkCheckGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: OkCheckGetSchema,
        options: {
          parameters: OkCheckGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<OkCheckGetData, OkCheckGetError>>
    ): Promise<RequestFnResponse<OkCheckGetData, OkCheckGetError>>;
    /** @summary Ok */
    getQueryKey(
      parameters: DeepReadonly<OkCheckGetParameters> | void
    ): ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.okCheckGet.useQuery()
     * ```
     */
    useQuery<TData = OkCheckGetData>(
      parameters:
        | ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          OkCheckGetData,
          OkCheckGetError,
          TData,
          ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<OkCheckGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.okCheckGet.useQuery()
     * ```
     */
    useQuery<TData = OkCheckGetData>(
      parameters:
        | ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          OkCheckGetData,
          OkCheckGetError,
          TData,
          ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<OkCheckGetError>>;
    /** @summary Ok */
    getInfiniteQueryKey(
      parameters: DeepReadonly<OkCheckGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.okCheckGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OkCheckGetParameters,
      TQueryFnData = OkCheckGetData,
      TData = OperationInfiniteData<TQueryFnData, OkCheckGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OkCheckGetError,
          TData,
          ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<OkCheckGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.okCheckGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OkCheckGetParameters,
      TQueryFnData = OkCheckGetData,
      TData = OperationInfiniteData<TQueryFnData, OkCheckGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OkCheckGetError,
          TData,
          ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<OkCheckGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<OkCheckGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const okCheckGetTotal = qraft.checkService.okCheckGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const okCheckGetResults = qraft.checkService.okCheckGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * okCheckGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const okCheckGetCombinedResults = qraft.checkService.okCheckGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * okCheckGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<OkCheckGetSchema, OkCheckGetParameters, OkCheckGetData, OkCheckGetError>
      >,
      TCombinedResult = Array<UseQueryResult<OkCheckGetData, OkCheckGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<OkCheckGetData, OkCheckGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.checkService.okCheckGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = OkCheckGetData>(
      parameters:
        | ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          OkCheckGetData,
          OkCheckGetError,
          TData,
          ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<OkCheckGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.okCheckGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends OkCheckGetParameters, TData = OkCheckGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          OkCheckGetData,
          OkCheckGetError,
          OperationInfiniteData<TData, OkCheckGetParameters>,
          ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<OkCheckGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, OkCheckGetParameters>,
      OperationError<OkCheckGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Ok
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const okCheckGetData = qraft.checkService.okCheckGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * okCheckGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const okCheckGetCombinedData = qraft.checkService.okCheckGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * okCheckGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<OkCheckGetSchema, OkCheckGetParameters, OkCheckGetData, OkCheckGetError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<OkCheckGetData, OkCheckGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<OkCheckGetData, OkCheckGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Ok */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OkCheckGetSchema,
        OkCheckGetData,
        OkCheckGetParameters,
        OkCheckGetError
      > | void
    ): Promise<OkCheckGetData>;
    /** @summary Ok */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OkCheckGetSchema,
        OkCheckGetData,
        OkCheckGetParameters,
        OkCheckGetError
      > | void
    ): Promise<void>;
    /** @summary Ok */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        OkCheckGetSchema,
        OkCheckGetData,
        OkCheckGetParameters,
        OkCheckGetError
      > | void
    ): Promise<OkCheckGetData>;
    /** @summary Ok */
    fetchInfiniteQuery<TPageParam extends OkCheckGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OkCheckGetSchema,
        OkCheckGetData,
        OkCheckGetParameters,
        DeepReadonly<TPageParam>,
        OkCheckGetError
      > | void
    ): Promise<OperationInfiniteData<OkCheckGetData, OkCheckGetParameters>>;
    /** @summary Ok */
    prefetchInfiniteQuery<TPageParam extends OkCheckGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OkCheckGetSchema,
        OkCheckGetData,
        OkCheckGetParameters,
        DeepReadonly<TPageParam>,
        OkCheckGetError
      > | void
    ): Promise<void>;
    /** @summary Ok */
    ensureInfiniteQueryData<TPageParam extends OkCheckGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        OkCheckGetSchema,
        OkCheckGetData,
        OkCheckGetParameters,
        DeepReadonly<TPageParam>,
        OkCheckGetError
      > | void
    ): Promise<OperationInfiniteData<OkCheckGetData, OkCheckGetParameters>>;
    /** @summary Ok */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void)
    ): OkCheckGetData | undefined;
    /** @summary Ok */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void)
    ): OperationInfiniteData<OkCheckGetData, OkCheckGetParameters> | undefined;
    /** @summary Ok */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>,
            data: NoInfer<OperationInfiniteData<OkCheckGetData, OkCheckGetParameters>> | undefined,
          ]
        >
      : Array<
          [queryKey: ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>, data: OkCheckGetData | undefined]
        >;
    /** @summary Ok */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | (DeepReadonly<OkCheckGetParameters> | void)
    ): QueryState<OkCheckGetData, OkCheckGetError> | undefined;
    /** @summary Ok */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<OkCheckGetParameters>
        | ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>
        | void
    ): QueryState<OperationInfiniteData<OkCheckGetData, OkCheckGetParameters>, OkCheckGetError> | undefined;
    /** @summary Ok */
    setQueryData(
      parameters:
        | (DeepReadonly<OkCheckGetParameters> | undefined)
        | ServiceOperationQueryKey<OkCheckGetSchema, OkCheckGetParameters>,
      updater: Updater<NoInfer<OkCheckGetData> | undefined, NoInfer<DeepReadonly<OkCheckGetData>> | undefined>,
      options?: SetDataOptions
    ): OkCheckGetData | undefined;
    /** @summary Ok */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<OkCheckGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<OkCheckGetSchema, OkCheckGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<OkCheckGetData, OkCheckGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<OkCheckGetData, OkCheckGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<OkCheckGetData, OkCheckGetParameters> | undefined;
    /** @summary Ok */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>,
      updater: Updater<NoInfer<OkCheckGetData> | undefined, NoInfer<OkCheckGetData> | undefined>,
      options?: SetDataOptions
    ): Array<OkCheckGetData | undefined>;
    /** @summary Ok */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        OkCheckGetSchema,
        OkCheckGetData,
        TInfinite,
        OkCheckGetParameters,
        OkCheckGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Ok */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Ok */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Ok */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
    ): void;
    /** @summary Ok */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Ok */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
        | QueryFiltersByQueryKey<OkCheckGetSchema, OkCheckGetData, TInfinite, OkCheckGetParameters, OkCheckGetError>
    ): number;
    schema: OkCheckGetSchema;
    types: {
      parameters: OkCheckGetParameters;
      data: OkCheckGetData;
      error: OkCheckGetError;
    };
  };
  /** @summary Error Unhandled */
  errorUnhandledCheckErrorUnhandledGet: {
    /** @summary Error Unhandled */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ErrorUnhandledCheckErrorUnhandledGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ErrorUnhandledCheckErrorUnhandledGetSchema,
        options: {
          parameters: ErrorUnhandledCheckErrorUnhandledGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError>
      >
    ): Promise<RequestFnResponse<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError>>;
    /** @summary Error Unhandled */
    getQueryKey(
      parameters: DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void
    ): ServiceOperationQueryKey<
      ErrorUnhandledCheckErrorUnhandledGetSchema,
      ErrorUnhandledCheckErrorUnhandledGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorUnhandledCheckErrorUnhandledGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ErrorUnhandledCheckErrorUnhandledGetData,
          ErrorUnhandledCheckErrorUnhandledGetError,
          TData,
          ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ErrorUnhandledCheckErrorUnhandledGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorUnhandledCheckErrorUnhandledGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ErrorUnhandledCheckErrorUnhandledGetData,
          ErrorUnhandledCheckErrorUnhandledGetError,
          TData,
          ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ErrorUnhandledCheckErrorUnhandledGetError>>;
    /** @summary Error Unhandled */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ErrorUnhandledCheckErrorUnhandledGetSchema,
      ErrorUnhandledCheckErrorUnhandledGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorUnhandledCheckErrorUnhandledGetParameters,
      TQueryFnData = ErrorUnhandledCheckErrorUnhandledGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorUnhandledCheckErrorUnhandledGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorUnhandledCheckErrorUnhandledGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ErrorUnhandledCheckErrorUnhandledGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorUnhandledCheckErrorUnhandledGetParameters,
      TQueryFnData = ErrorUnhandledCheckErrorUnhandledGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorUnhandledCheckErrorUnhandledGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorUnhandledCheckErrorUnhandledGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ErrorUnhandledCheckErrorUnhandledGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ErrorUnhandledCheckErrorUnhandledGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const errorUnhandledCheckErrorUnhandledGetTotal = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const errorUnhandledCheckErrorUnhandledGetResults = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorUnhandledCheckErrorUnhandledGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const errorUnhandledCheckErrorUnhandledGetCombinedResults = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorUnhandledCheckErrorUnhandledGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ErrorUnhandledCheckErrorUnhandledGetSchema,
          ErrorUnhandledCheckErrorUnhandledGetParameters,
          ErrorUnhandledCheckErrorUnhandledGetData,
          ErrorUnhandledCheckErrorUnhandledGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ErrorUnhandledCheckErrorUnhandledGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ErrorUnhandledCheckErrorUnhandledGetData,
          ErrorUnhandledCheckErrorUnhandledGetError,
          TData,
          ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ErrorUnhandledCheckErrorUnhandledGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ErrorUnhandledCheckErrorUnhandledGetParameters,
      TData = ErrorUnhandledCheckErrorUnhandledGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ErrorUnhandledCheckErrorUnhandledGetData,
          ErrorUnhandledCheckErrorUnhandledGetError,
          OperationInfiniteData<TData, ErrorUnhandledCheckErrorUnhandledGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ErrorUnhandledCheckErrorUnhandledGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ErrorUnhandledCheckErrorUnhandledGetParameters>,
      OperationError<ErrorUnhandledCheckErrorUnhandledGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Error Unhandled
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const errorUnhandledCheckErrorUnhandledGetData = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorUnhandledCheckErrorUnhandledGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const errorUnhandledCheckErrorUnhandledGetCombinedData = qraft.checkService.errorUnhandledCheckErrorUnhandledGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorUnhandledCheckErrorUnhandledGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ErrorUnhandledCheckErrorUnhandledGetSchema,
          ErrorUnhandledCheckErrorUnhandledGetParameters,
          ErrorUnhandledCheckErrorUnhandledGetData,
          ErrorUnhandledCheckErrorUnhandledGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Error Unhandled */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        ErrorUnhandledCheckErrorUnhandledGetError
      > | void
    ): Promise<ErrorUnhandledCheckErrorUnhandledGetData>;
    /** @summary Error Unhandled */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        ErrorUnhandledCheckErrorUnhandledGetError
      > | void
    ): Promise<void>;
    /** @summary Error Unhandled */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        ErrorUnhandledCheckErrorUnhandledGetError
      > | void
    ): Promise<ErrorUnhandledCheckErrorUnhandledGetData>;
    /** @summary Error Unhandled */
    fetchInfiniteQuery<TPageParam extends ErrorUnhandledCheckErrorUnhandledGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        DeepReadonly<TPageParam>,
        ErrorUnhandledCheckErrorUnhandledGetError
      > | void
    ): Promise<
      OperationInfiniteData<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetParameters>
    >;
    /** @summary Error Unhandled */
    prefetchInfiniteQuery<TPageParam extends ErrorUnhandledCheckErrorUnhandledGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        DeepReadonly<TPageParam>,
        ErrorUnhandledCheckErrorUnhandledGetError
      > | void
    ): Promise<void>;
    /** @summary Error Unhandled */
    ensureInfiniteQueryData<TPageParam extends ErrorUnhandledCheckErrorUnhandledGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        DeepReadonly<TPageParam>,
        ErrorUnhandledCheckErrorUnhandledGetError
      > | void
    ): Promise<
      OperationInfiniteData<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetParameters>
    >;
    /** @summary Error Unhandled */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void)
    ): ErrorUnhandledCheckErrorUnhandledGetData | undefined;
    /** @summary Error Unhandled */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void)
    ):
      | OperationInfiniteData<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetParameters>
      | undefined;
    /** @summary Error Unhandled */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ErrorUnhandledCheckErrorUnhandledGetSchema,
              ErrorUnhandledCheckErrorUnhandledGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ErrorUnhandledCheckErrorUnhandledGetData,
                    ErrorUnhandledCheckErrorUnhandledGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ErrorUnhandledCheckErrorUnhandledGetSchema,
              ErrorUnhandledCheckErrorUnhandledGetParameters
            >,
            data: ErrorUnhandledCheckErrorUnhandledGetData | undefined,
          ]
        >;
    /** @summary Error Unhandled */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | void)
    ): QueryState<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetError> | undefined;
    /** @summary Error Unhandled */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ErrorUnhandledCheckErrorUnhandledGetData,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >,
          ErrorUnhandledCheckErrorUnhandledGetError
        >
      | undefined;
    /** @summary Error Unhandled */
    setQueryData(
      parameters:
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >,
      updater: Updater<
        NoInfer<ErrorUnhandledCheckErrorUnhandledGetData> | undefined,
        NoInfer<DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ErrorUnhandledCheckErrorUnhandledGetData | undefined;
    /** @summary Error Unhandled */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ErrorUnhandledCheckErrorUnhandledGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ErrorUnhandledCheckErrorUnhandledGetData,
              ErrorUnhandledCheckErrorUnhandledGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ErrorUnhandledCheckErrorUnhandledGetData,
                ErrorUnhandledCheckErrorUnhandledGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<ErrorUnhandledCheckErrorUnhandledGetData, ErrorUnhandledCheckErrorUnhandledGetParameters>
      | undefined;
    /** @summary Error Unhandled */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >,
      updater: Updater<
        NoInfer<ErrorUnhandledCheckErrorUnhandledGetData> | undefined,
        NoInfer<ErrorUnhandledCheckErrorUnhandledGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ErrorUnhandledCheckErrorUnhandledGetData | undefined>;
    /** @summary Error Unhandled */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ErrorUnhandledCheckErrorUnhandledGetSchema,
        ErrorUnhandledCheckErrorUnhandledGetData,
        TInfinite,
        ErrorUnhandledCheckErrorUnhandledGetParameters,
        ErrorUnhandledCheckErrorUnhandledGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Error Unhandled */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Error Unhandled */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Error Unhandled */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
    ): void;
    /** @summary Error Unhandled */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Error Unhandled */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
        | QueryFiltersByQueryKey<
            ErrorUnhandledCheckErrorUnhandledGetSchema,
            ErrorUnhandledCheckErrorUnhandledGetData,
            TInfinite,
            ErrorUnhandledCheckErrorUnhandledGetParameters,
            ErrorUnhandledCheckErrorUnhandledGetError
          >
    ): number;
    schema: ErrorUnhandledCheckErrorUnhandledGetSchema;
    types: {
      parameters: ErrorUnhandledCheckErrorUnhandledGetParameters;
      data: ErrorUnhandledCheckErrorUnhandledGetData;
      error: ErrorUnhandledCheckErrorUnhandledGetError;
    };
  };
  /** @summary Error Division By Zero */
  errorDivisionByZeroCheckErrorDivisionByZeroGet: {
    /** @summary Error Division By Zero */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        options: {
          parameters: ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      >
    >;
    /** @summary Error Division By Zero */
    getQueryKey(
      parameters: DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void
    ): ServiceOperationQueryKey<
      ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
      ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorDivisionByZeroCheckErrorDivisionByZeroGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError,
          TData,
          ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ErrorDivisionByZeroCheckErrorDivisionByZeroGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorDivisionByZeroCheckErrorDivisionByZeroGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError,
          TData,
          ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ErrorDivisionByZeroCheckErrorDivisionByZeroGetError>>;
    /** @summary Error Division By Zero */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
      ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
      TQueryFnData = ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ErrorDivisionByZeroCheckErrorDivisionByZeroGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
      TQueryFnData = ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ErrorDivisionByZeroCheckErrorDivisionByZeroGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const errorDivisionByZeroCheckErrorDivisionByZeroGetTotal = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const errorDivisionByZeroCheckErrorDivisionByZeroGetResults = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorDivisionByZeroCheckErrorDivisionByZeroGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const errorDivisionByZeroCheckErrorDivisionByZeroGetCombinedResults = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorDivisionByZeroCheckErrorDivisionByZeroGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ErrorDivisionByZeroCheckErrorDivisionByZeroGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError,
          TData,
          ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ErrorDivisionByZeroCheckErrorDivisionByZeroGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
      TData = ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError,
          OperationInfiniteData<TData, ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>,
      OperationError<ErrorDivisionByZeroCheckErrorDivisionByZeroGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Error Division By Zero
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const errorDivisionByZeroCheckErrorDivisionByZeroGetData = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorDivisionByZeroCheckErrorDivisionByZeroGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const errorDivisionByZeroCheckErrorDivisionByZeroGetCombinedData = qraft.checkService.errorDivisionByZeroCheckErrorDivisionByZeroGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorDivisionByZeroCheckErrorDivisionByZeroGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Error Division By Zero */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      > | void
    ): Promise<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData>;
    /** @summary Error Division By Zero */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      > | void
    ): Promise<void>;
    /** @summary Error Division By Zero */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      > | void
    ): Promise<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData>;
    /** @summary Error Division By Zero */
    fetchInfiniteQuery<TPageParam extends ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        DeepReadonly<TPageParam>,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
      >
    >;
    /** @summary Error Division By Zero */
    prefetchInfiniteQuery<TPageParam extends ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        DeepReadonly<TPageParam>,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      > | void
    ): Promise<void>;
    /** @summary Error Division By Zero */
    ensureInfiniteQueryData<TPageParam extends ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        DeepReadonly<TPageParam>,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
      >
    >;
    /** @summary Error Division By Zero */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void)
    ): ErrorDivisionByZeroCheckErrorDivisionByZeroGetData | undefined;
    /** @summary Error Division By Zero */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void)
    ):
      | OperationInfiniteData<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
        >
      | undefined;
    /** @summary Error Division By Zero */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
                    ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
            >,
            data: ErrorDivisionByZeroCheckErrorDivisionByZeroGetData | undefined,
          ]
        >;
    /** @summary Error Division By Zero */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | void)
    ):
      | QueryState<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      | undefined;
    /** @summary Error Division By Zero */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
        >
      | undefined;
    /** @summary Error Division By Zero */
    setQueryData(
      parameters:
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >,
      updater: Updater<
        NoInfer<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData> | undefined,
        NoInfer<DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ErrorDivisionByZeroCheckErrorDivisionByZeroGetData | undefined;
    /** @summary Error Division By Zero */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
              ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
                ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
          ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters
        >
      | undefined;
    /** @summary Error Division By Zero */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >,
      updater: Updater<
        NoInfer<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData> | undefined,
        NoInfer<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ErrorDivisionByZeroCheckErrorDivisionByZeroGetData | undefined>;
    /** @summary Error Division By Zero */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
        TInfinite,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
        ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Error Division By Zero */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Error Division By Zero */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Error Division By Zero */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
    ): void;
    /** @summary Error Division By Zero */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Error Division By Zero */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
        | QueryFiltersByQueryKey<
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetData,
            TInfinite,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters,
            ErrorDivisionByZeroCheckErrorDivisionByZeroGetError
          >
    ): number;
    schema: ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema;
    types: {
      parameters: ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters;
      data: ErrorDivisionByZeroCheckErrorDivisionByZeroGetData;
      error: ErrorDivisionByZeroCheckErrorDivisionByZeroGetError;
    };
  };
  /** @summary Error Caught */
  errorCaughtCheckErrorCaughtGet: {
    /** @summary Error Caught */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ErrorCaughtCheckErrorCaughtGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ErrorCaughtCheckErrorCaughtGetSchema,
        options: {
          parameters: ErrorCaughtCheckErrorCaughtGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError>>
    ): Promise<RequestFnResponse<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError>>;
    /** @summary Error Caught */
    getQueryKey(
      parameters: DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void
    ): ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorCaughtCheckErrorCaughtGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorCaughtCheckErrorCaughtGetData>(
      parameters:
        | ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ErrorCaughtCheckErrorCaughtGetData,
          ErrorCaughtCheckErrorCaughtGetError,
          TData,
          ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ErrorCaughtCheckErrorCaughtGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorCaughtCheckErrorCaughtGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorCaughtCheckErrorCaughtGetData>(
      parameters:
        | ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ErrorCaughtCheckErrorCaughtGetData,
          ErrorCaughtCheckErrorCaughtGetError,
          TData,
          ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ErrorCaughtCheckErrorCaughtGetError>>;
    /** @summary Error Caught */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorCaughtCheckErrorCaughtGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorCaughtCheckErrorCaughtGetParameters,
      TQueryFnData = ErrorCaughtCheckErrorCaughtGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorCaughtCheckErrorCaughtGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorCaughtCheckErrorCaughtGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ErrorCaughtCheckErrorCaughtGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorCaughtCheckErrorCaughtGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorCaughtCheckErrorCaughtGetParameters,
      TQueryFnData = ErrorCaughtCheckErrorCaughtGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorCaughtCheckErrorCaughtGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorCaughtCheckErrorCaughtGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ErrorCaughtCheckErrorCaughtGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ErrorCaughtCheckErrorCaughtGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const errorCaughtCheckErrorCaughtGetTotal = qraft.checkService.errorCaughtCheckErrorCaughtGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const errorCaughtCheckErrorCaughtGetResults = qraft.checkService.errorCaughtCheckErrorCaughtGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorCaughtCheckErrorCaughtGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const errorCaughtCheckErrorCaughtGetCombinedResults = qraft.checkService.errorCaughtCheckErrorCaughtGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorCaughtCheckErrorCaughtGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ErrorCaughtCheckErrorCaughtGetSchema,
          ErrorCaughtCheckErrorCaughtGetParameters,
          ErrorCaughtCheckErrorCaughtGetData,
          ErrorCaughtCheckErrorCaughtGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.checkService.errorCaughtCheckErrorCaughtGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ErrorCaughtCheckErrorCaughtGetData>(
      parameters:
        | ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ErrorCaughtCheckErrorCaughtGetData,
          ErrorCaughtCheckErrorCaughtGetError,
          TData,
          ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ErrorCaughtCheckErrorCaughtGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorCaughtCheckErrorCaughtGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ErrorCaughtCheckErrorCaughtGetParameters,
      TData = ErrorCaughtCheckErrorCaughtGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ErrorCaughtCheckErrorCaughtGetData,
          ErrorCaughtCheckErrorCaughtGetError,
          OperationInfiniteData<TData, ErrorCaughtCheckErrorCaughtGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ErrorCaughtCheckErrorCaughtGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ErrorCaughtCheckErrorCaughtGetParameters>,
      OperationError<ErrorCaughtCheckErrorCaughtGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Error Caught
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const errorCaughtCheckErrorCaughtGetData = qraft.checkService.errorCaughtCheckErrorCaughtGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorCaughtCheckErrorCaughtGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const errorCaughtCheckErrorCaughtGetCombinedData = qraft.checkService.errorCaughtCheckErrorCaughtGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorCaughtCheckErrorCaughtGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ErrorCaughtCheckErrorCaughtGetSchema,
          ErrorCaughtCheckErrorCaughtGetParameters,
          ErrorCaughtCheckErrorCaughtGetData,
          ErrorCaughtCheckErrorCaughtGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Error Caught */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        ErrorCaughtCheckErrorCaughtGetParameters,
        ErrorCaughtCheckErrorCaughtGetError
      > | void
    ): Promise<ErrorCaughtCheckErrorCaughtGetData>;
    /** @summary Error Caught */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        ErrorCaughtCheckErrorCaughtGetParameters,
        ErrorCaughtCheckErrorCaughtGetError
      > | void
    ): Promise<void>;
    /** @summary Error Caught */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        ErrorCaughtCheckErrorCaughtGetParameters,
        ErrorCaughtCheckErrorCaughtGetError
      > | void
    ): Promise<ErrorCaughtCheckErrorCaughtGetData>;
    /** @summary Error Caught */
    fetchInfiniteQuery<TPageParam extends ErrorCaughtCheckErrorCaughtGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        ErrorCaughtCheckErrorCaughtGetParameters,
        DeepReadonly<TPageParam>,
        ErrorCaughtCheckErrorCaughtGetError
      > | void
    ): Promise<OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters>>;
    /** @summary Error Caught */
    prefetchInfiniteQuery<TPageParam extends ErrorCaughtCheckErrorCaughtGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        ErrorCaughtCheckErrorCaughtGetParameters,
        DeepReadonly<TPageParam>,
        ErrorCaughtCheckErrorCaughtGetError
      > | void
    ): Promise<void>;
    /** @summary Error Caught */
    ensureInfiniteQueryData<TPageParam extends ErrorCaughtCheckErrorCaughtGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        ErrorCaughtCheckErrorCaughtGetParameters,
        DeepReadonly<TPageParam>,
        ErrorCaughtCheckErrorCaughtGetError
      > | void
    ): Promise<OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters>>;
    /** @summary Error Caught */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void)
    ): ErrorCaughtCheckErrorCaughtGetData | undefined;
    /** @summary Error Caught */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void)
    ): OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters> | undefined;
    /** @summary Error Caught */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ErrorCaughtCheckErrorCaughtGetSchema,
              ErrorCaughtCheckErrorCaughtGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters>
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ErrorCaughtCheckErrorCaughtGetSchema,
              ErrorCaughtCheckErrorCaughtGetParameters
            >,
            data: ErrorCaughtCheckErrorCaughtGetData | undefined,
          ]
        >;
    /** @summary Error Caught */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | void)
    ): QueryState<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetError> | undefined;
    /** @summary Error Caught */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters>,
          ErrorCaughtCheckErrorCaughtGetError
        >
      | undefined;
    /** @summary Error Caught */
    setQueryData(
      parameters:
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | undefined)
        | ServiceOperationQueryKey<ErrorCaughtCheckErrorCaughtGetSchema, ErrorCaughtCheckErrorCaughtGetParameters>,
      updater: Updater<
        NoInfer<ErrorCaughtCheckErrorCaughtGetData> | undefined,
        NoInfer<DeepReadonly<ErrorCaughtCheckErrorCaughtGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ErrorCaughtCheckErrorCaughtGetData | undefined;
    /** @summary Error Caught */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ErrorCaughtCheckErrorCaughtGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetParameters
          >,
      updater: Updater<
        | NoInfer<OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ErrorCaughtCheckErrorCaughtGetData, ErrorCaughtCheckErrorCaughtGetParameters> | undefined;
    /** @summary Error Caught */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >,
      updater: Updater<
        NoInfer<ErrorCaughtCheckErrorCaughtGetData> | undefined,
        NoInfer<ErrorCaughtCheckErrorCaughtGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ErrorCaughtCheckErrorCaughtGetData | undefined>;
    /** @summary Error Caught */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ErrorCaughtCheckErrorCaughtGetSchema,
        ErrorCaughtCheckErrorCaughtGetData,
        TInfinite,
        ErrorCaughtCheckErrorCaughtGetParameters,
        ErrorCaughtCheckErrorCaughtGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Error Caught */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Error Caught */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Error Caught */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
    ): void;
    /** @summary Error Caught */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Error Caught */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
        | QueryFiltersByQueryKey<
            ErrorCaughtCheckErrorCaughtGetSchema,
            ErrorCaughtCheckErrorCaughtGetData,
            TInfinite,
            ErrorCaughtCheckErrorCaughtGetParameters,
            ErrorCaughtCheckErrorCaughtGetError
          >
    ): number;
    schema: ErrorCaughtCheckErrorCaughtGetSchema;
    types: {
      parameters: ErrorCaughtCheckErrorCaughtGetParameters;
      data: ErrorCaughtCheckErrorCaughtGetData;
      error: ErrorCaughtCheckErrorCaughtGetError;
    };
  };
  /** @summary Error Http */
  errorHttpCheckErrorHttpGet: {
    /** @summary Error Http */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ErrorHttpCheckErrorHttpGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ErrorHttpCheckErrorHttpGetSchema,
        options: {
          parameters: ErrorHttpCheckErrorHttpGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError>>
    ): Promise<RequestFnResponse<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError>>;
    /** @summary Error Http */
    getQueryKey(
      parameters: DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void
    ): ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorHttpCheckErrorHttpGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorHttpCheckErrorHttpGetData>(
      parameters:
        | ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ErrorHttpCheckErrorHttpGetData,
          ErrorHttpCheckErrorHttpGetError,
          TData,
          ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ErrorHttpCheckErrorHttpGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.checkService.errorHttpCheckErrorHttpGet.useQuery()
     * ```
     */
    useQuery<TData = ErrorHttpCheckErrorHttpGetData>(
      parameters:
        | ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ErrorHttpCheckErrorHttpGetData,
          ErrorHttpCheckErrorHttpGetError,
          TData,
          ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ErrorHttpCheckErrorHttpGetError>>;
    /** @summary Error Http */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorHttpCheckErrorHttpGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorHttpCheckErrorHttpGetParameters,
      TQueryFnData = ErrorHttpCheckErrorHttpGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorHttpCheckErrorHttpGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorHttpCheckErrorHttpGetError,
          TData,
          ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ErrorHttpCheckErrorHttpGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorHttpCheckErrorHttpGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ErrorHttpCheckErrorHttpGetParameters,
      TQueryFnData = ErrorHttpCheckErrorHttpGetData,
      TData = OperationInfiniteData<TQueryFnData, ErrorHttpCheckErrorHttpGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ErrorHttpCheckErrorHttpGetError,
          TData,
          ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ErrorHttpCheckErrorHttpGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ErrorHttpCheckErrorHttpGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const errorHttpCheckErrorHttpGetTotal = qraft.checkService.errorHttpCheckErrorHttpGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const errorHttpCheckErrorHttpGetResults = qraft.checkService.errorHttpCheckErrorHttpGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorHttpCheckErrorHttpGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const errorHttpCheckErrorHttpGetCombinedResults = qraft.checkService.errorHttpCheckErrorHttpGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorHttpCheckErrorHttpGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ErrorHttpCheckErrorHttpGetSchema,
          ErrorHttpCheckErrorHttpGetParameters,
          ErrorHttpCheckErrorHttpGetData,
          ErrorHttpCheckErrorHttpGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.checkService.errorHttpCheckErrorHttpGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ErrorHttpCheckErrorHttpGetData>(
      parameters:
        | ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ErrorHttpCheckErrorHttpGetData,
          ErrorHttpCheckErrorHttpGetError,
          TData,
          ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ErrorHttpCheckErrorHttpGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.checkService.errorHttpCheckErrorHttpGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ErrorHttpCheckErrorHttpGetParameters,
      TData = ErrorHttpCheckErrorHttpGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ErrorHttpCheckErrorHttpGetData,
          ErrorHttpCheckErrorHttpGetError,
          OperationInfiniteData<TData, ErrorHttpCheckErrorHttpGetParameters>,
          ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ErrorHttpCheckErrorHttpGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ErrorHttpCheckErrorHttpGetParameters>,
      OperationError<ErrorHttpCheckErrorHttpGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Error Http
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const errorHttpCheckErrorHttpGetData = qraft.checkService.errorHttpCheckErrorHttpGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorHttpCheckErrorHttpGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const errorHttpCheckErrorHttpGetCombinedData = qraft.checkService.errorHttpCheckErrorHttpGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * errorHttpCheckErrorHttpGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ErrorHttpCheckErrorHttpGetSchema,
          ErrorHttpCheckErrorHttpGetParameters,
          ErrorHttpCheckErrorHttpGetData,
          ErrorHttpCheckErrorHttpGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Error Http */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        ErrorHttpCheckErrorHttpGetParameters,
        ErrorHttpCheckErrorHttpGetError
      > | void
    ): Promise<ErrorHttpCheckErrorHttpGetData>;
    /** @summary Error Http */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        ErrorHttpCheckErrorHttpGetParameters,
        ErrorHttpCheckErrorHttpGetError
      > | void
    ): Promise<void>;
    /** @summary Error Http */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        ErrorHttpCheckErrorHttpGetParameters,
        ErrorHttpCheckErrorHttpGetError
      > | void
    ): Promise<ErrorHttpCheckErrorHttpGetData>;
    /** @summary Error Http */
    fetchInfiniteQuery<TPageParam extends ErrorHttpCheckErrorHttpGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        ErrorHttpCheckErrorHttpGetParameters,
        DeepReadonly<TPageParam>,
        ErrorHttpCheckErrorHttpGetError
      > | void
    ): Promise<OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters>>;
    /** @summary Error Http */
    prefetchInfiniteQuery<TPageParam extends ErrorHttpCheckErrorHttpGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        ErrorHttpCheckErrorHttpGetParameters,
        DeepReadonly<TPageParam>,
        ErrorHttpCheckErrorHttpGetError
      > | void
    ): Promise<void>;
    /** @summary Error Http */
    ensureInfiniteQueryData<TPageParam extends ErrorHttpCheckErrorHttpGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        ErrorHttpCheckErrorHttpGetParameters,
        DeepReadonly<TPageParam>,
        ErrorHttpCheckErrorHttpGetError
      > | void
    ): Promise<OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters>>;
    /** @summary Error Http */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void)
    ): ErrorHttpCheckErrorHttpGetData | undefined;
    /** @summary Error Http */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void)
    ): OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters> | undefined;
    /** @summary Error Http */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ErrorHttpCheckErrorHttpGetSchema,
              ErrorHttpCheckErrorHttpGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>,
            data: ErrorHttpCheckErrorHttpGetData | undefined,
          ]
        >;
    /** @summary Error Http */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | void)
    ): QueryState<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetError> | undefined;
    /** @summary Error Http */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ErrorHttpCheckErrorHttpGetParameters>
        | ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters>,
          ErrorHttpCheckErrorHttpGetError
        >
      | undefined;
    /** @summary Error Http */
    setQueryData(
      parameters:
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | undefined)
        | ServiceOperationQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>,
      updater: Updater<
        NoInfer<ErrorHttpCheckErrorHttpGetData> | undefined,
        NoInfer<DeepReadonly<ErrorHttpCheckErrorHttpGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ErrorHttpCheckErrorHttpGetData | undefined;
    /** @summary Error Http */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ErrorHttpCheckErrorHttpGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ErrorHttpCheckErrorHttpGetSchema, ErrorHttpCheckErrorHttpGetParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ErrorHttpCheckErrorHttpGetData, ErrorHttpCheckErrorHttpGetParameters> | undefined;
    /** @summary Error Http */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >,
      updater: Updater<
        NoInfer<ErrorHttpCheckErrorHttpGetData> | undefined,
        NoInfer<ErrorHttpCheckErrorHttpGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ErrorHttpCheckErrorHttpGetData | undefined>;
    /** @summary Error Http */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ErrorHttpCheckErrorHttpGetSchema,
        ErrorHttpCheckErrorHttpGetData,
        TInfinite,
        ErrorHttpCheckErrorHttpGetParameters,
        ErrorHttpCheckErrorHttpGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Error Http */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Error Http */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Error Http */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
    ): void;
    /** @summary Error Http */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Error Http */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
        | QueryFiltersByQueryKey<
            ErrorHttpCheckErrorHttpGetSchema,
            ErrorHttpCheckErrorHttpGetData,
            TInfinite,
            ErrorHttpCheckErrorHttpGetParameters,
            ErrorHttpCheckErrorHttpGetError
          >
    ): number;
    schema: ErrorHttpCheckErrorHttpGetSchema;
    types: {
      parameters: ErrorHttpCheckErrorHttpGetParameters;
      data: ErrorHttpCheckErrorHttpGetData;
      error: ErrorHttpCheckErrorHttpGetError;
    };
  };
}
/** @summary Ok */
export const okCheckGet = {
  schema: {
    method: 'get',
    url: '/check/',
  },
} as {
  schema: OkCheckGetSchema;
  [QraftServiceOperationsToken]: CheckService['okCheckGet'];
};
/** @summary Error Unhandled */
export const errorUnhandledCheckErrorUnhandledGet = {
  schema: {
    method: 'get',
    url: '/check/error/unhandled',
  },
} as {
  schema: ErrorUnhandledCheckErrorUnhandledGetSchema;
  [QraftServiceOperationsToken]: CheckService['errorUnhandledCheckErrorUnhandledGet'];
};
/** @summary Error Division By Zero */
export const errorDivisionByZeroCheckErrorDivisionByZeroGet = {
  schema: {
    method: 'get',
    url: '/check/error/division-by-zero',
  },
} as {
  schema: ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema;
  [QraftServiceOperationsToken]: CheckService['errorDivisionByZeroCheckErrorDivisionByZeroGet'];
};
/** @summary Error Caught */
export const errorCaughtCheckErrorCaughtGet = {
  schema: {
    method: 'get',
    url: '/check/error/caught',
  },
} as {
  schema: ErrorCaughtCheckErrorCaughtGetSchema;
  [QraftServiceOperationsToken]: CheckService['errorCaughtCheckErrorCaughtGet'];
};
/** @summary Error Http */
export const errorHttpCheckErrorHttpGet = {
  schema: {
    method: 'get',
    url: '/check/error/http',
  },
} as {
  schema: ErrorHttpCheckErrorHttpGetSchema;
  [QraftServiceOperationsToken]: CheckService['errorHttpCheckErrorHttpGet'];
};
export const checkService = {
  okCheckGet,
  errorUnhandledCheckErrorUnhandledGet,
  errorDivisionByZeroCheckErrorDivisionByZeroGet,
  errorCaughtCheckErrorCaughtGet,
  errorHttpCheckErrorHttpGet,
} as const;
type OkCheckGetSchema = {
  method: 'get';
  url: '/check/';
};
type OkCheckGetParameters = undefined;
type OkCheckGetData = paths['/check/']['get']['responses']['200']['content']['application/json'];
type OkCheckGetError = unknown;
type ErrorUnhandledCheckErrorUnhandledGetSchema = {
  method: 'get';
  url: '/check/error/unhandled';
};
type ErrorUnhandledCheckErrorUnhandledGetParameters = undefined;
type ErrorUnhandledCheckErrorUnhandledGetData =
  paths['/check/error/unhandled']['get']['responses']['200']['content']['application/json'];
type ErrorUnhandledCheckErrorUnhandledGetError = unknown;
type ErrorDivisionByZeroCheckErrorDivisionByZeroGetSchema = {
  method: 'get';
  url: '/check/error/division-by-zero';
};
type ErrorDivisionByZeroCheckErrorDivisionByZeroGetParameters = undefined;
type ErrorDivisionByZeroCheckErrorDivisionByZeroGetData =
  paths['/check/error/division-by-zero']['get']['responses']['200']['content']['application/json'];
type ErrorDivisionByZeroCheckErrorDivisionByZeroGetError = unknown;
type ErrorCaughtCheckErrorCaughtGetSchema = {
  method: 'get';
  url: '/check/error/caught';
};
type ErrorCaughtCheckErrorCaughtGetParameters = undefined;
type ErrorCaughtCheckErrorCaughtGetData =
  paths['/check/error/caught']['get']['responses']['200']['content']['application/json'];
type ErrorCaughtCheckErrorCaughtGetError = unknown;
type ErrorHttpCheckErrorHttpGetSchema = {
  method: 'get';
  url: '/check/error/http';
};
type ErrorHttpCheckErrorHttpGetParameters = undefined;
type ErrorHttpCheckErrorHttpGetData =
  paths['/check/error/http']['get']['responses']['200']['content']['application/json'];
type ErrorHttpCheckErrorHttpGetError = unknown;
